import RangeSelector from './RangeSelector';
import RangeSelectorButton from './RangeSelectorButton';
import RangeSelectorInput from './RangeSelectorInput';
var ChartRangeSelector = RangeSelector;
ChartRangeSelector.Button = RangeSelectorButton;
ChartRangeSelector.Input = RangeSelectorInput;
export default ChartRangeSelector;